var _excluded = ["children", "optionsHeight"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import useStyles from './use_styles';
import Scrollbar from '../../scrollbar';
import highContrastMediaQuery from '../../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
import { jsx as ___EmotionJSX } from "@emotion/core";
var OptionsList = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      optionsHeight
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles({
    optionsHeight
  });
  var theme = useTheme();
  return ___EmotionJSX(Scrollbar, _extends({
    component: "ul",
    customStyle: [styles.root, optionsHeight && styles.height, highContrastMediaQuery(theme)],
    ref: ref,
    role: "listbox",
    tabIndex: -1
  }, props), children);
});
OptionsList.displayName = 'OptionsList';
export default OptionsList;